




import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as links from "@/data/sources/auditLinks"
import {executeQuery} from "@/data/repos/query"
import {formatDate} from "@/data/sources/dates";

@Component({
    components: {
      DataGrid,
    },
  })
  export default class AuditFailureByResponsibilityGroupDrillDown extends Vue {
    @Prop() public args!: {
      fromDate: string,
      toDate: string,
      responsibilityGroupId: number,
      categoryId: number,
      auditStatus: number,
    }
    public fields = [
      {name: 'regionName', title: 'Region', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportRegion},
      {name: 'siteName', title: 'Site', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportSite},
      {name: 'buildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportBuilding},
      {name: 'floorName', title: 'Floor', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportFloor},
      {name: 'roomName', title: 'Room', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.auditReportRoom},
      {name: 'elementName', title: 'Element', dataType: DataType.Text, sort: 1},
      {name: 'actionName', title: 'Action', dataType: DataType.Text, sort: 1},
      {name: 'releaseDate', title: 'Release Date', dataType: DataType.Date, sort: 1},
      {name: 'functionalarea', title: 'Functional Area', dataType: DataType.Text, sort: 1},
      {name: 'team', title: 'Team', dataType: DataType.Text, sort: 1},
    ]

    public getData(offset = 0, limit = 200) {
      // Out: {
      // "auditID":10686,
      // "roomID":32600,
      // "releaseDate":"2018-12-07T00:00:00.000+0000",
      // "functionalarea":"Ground Floor General Admin",
      // "team":"Team Tim",
      // "Location":"|OCS, OCS|OCS|OCS/CNWL Northwick Park Hospital Site|Level 0, L0|Room 004  ADL Kitchen - S14, Room 004"
      // }
      return executeQuery(
        "micad4-audit", "failureByResponsibilityGroup_Grid",
        {locale: "en-GB", fromDate: this.args.fromDate, toDate: this.args.toDate,
          responsibilityGroupID: this.args.responsibilityGroupId,
          categoryID: this.args.categoryId,
          auditStatus: this.args.auditStatus,
          completed: "A"},
        this.filter, offset, limit)
    }

    private filter(data: any[]): any[] {
      return data.map(item => {
        const locations = item.Location.split("|")
        return {
          ...item,
          regionName: locations[1],
          siteName: locations[2],
          buildingName: locations[3],
          floorName: locations[4],
          roomName: locations[5],
          releaseDate: formatDate(new Date(item.releaseDate)),
          categoryId: this.args.categoryId,
          responsibilityGroupId: this.args.responsibilityGroupId,
        }
      })
    }
  }
